<script setup>

const props = defineProps({
  company: {
    type: Object,
  },
	entertainment: {
		type: Boolean,
		default: false
	},
	companyLegal: {
		type: Object
	}
})

</script>

<template>
	<div class="mt-8 lg:mt-4">
		<div class="text-2xl fvs600 leading-[130%] tracking-[-0.36px]" :class="[entertainment ? 'mt-1 mb-5' : 'mb-6']">{{ company.name }}</div>
		<p class="text-base xl:text-lg">{{ company.street }}</p>
		<p class="text-base xl:text-lg mb-6">{{ company.city }}</p>
		<p class="text-base xl:text-lg"><strong>IČ:</strong> {{ company.cin }}</p>
		<p class="text-base xl:text-lg mb-6"><strong>DIČ:</strong> {{ company.tin }}</p>
		<p class="text-base xl:text-lg fvs600">Spisová značka:</p>
		<p class="text-base xl:text-lg mb-6">{{ company.filemark }}</p>

		<p v-if="company.phone" class="text-base xl:text-lg mb-1">
			<strong>Tel.:</strong> <a :href="`tel:${company.email}`" class="link" target="_blank">{{ company.phone }}</a>
		</p>

		<p v-if="company.email" class="text-base xl:text-lg leading-[140%]">
			<strong>E-mail:</strong> <a :href="`mailto:${company.email}`" class="link" target="_blank">{{ company.email }}</a>
		</p>

		<div class="mt-6" v-if="companyLegal">
			<NuxtLinkLocale class="text-base xl:text-lg link" to="information-on-the-book-entry-of-shares">Informace o zaknihování akcií</NuxtLinkLocale>
		</div>

	</div>
</template>